<template>
  <v-app>
    <Header/>
    <Sidebar/>
    <v-content>
      <v-container fluid py-2 px-3 style="padding-bottom: 0 !important;">
        <v-layout wrap>
          <v-flex text-xs-left xs12 md5 px-3>
            <v-autocomplete :items="filterSuppliers" v-model="filterSupplierList" item-text="name" prepend-icon="a-factory" return-object multiple @change="loadSupplierSummaries" class="supplierFilter"/>
          </v-flex>
          <v-flex text-xs-left xs12 md7>
            <v-autocomplete :items="filterFields" v-model="filterFieldList" item-text="displayName" prepend-icon="a-address" return-object multiple @change="loadSupplierSummaries" class="fieldFilter"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid py-3 px-3 v-if="showSupplier">
        <v-layout style="max-height: calc(100vh - 170px);">
          <v-flex style="border: 1px solid #DDDDDD; border-radius: 3px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="supplierSummaries" hide-actions no-data-text="No supplier data found" class="salesTable" :key="updateCounter">
              <template v-slot:items="props">
                <tr :class="rowClass(props.item)" v-if="showItem(props.item)">
                  <td class="text-xs-left" style="width: 15px; padding-left: 5px !important; padding-right: 0 !important; padding-top: 1px !important;'">
                    <v-icon style="font-size: 20px;" v-if="showExpandIcon(props.item)" @click="categoryClicked(props.item)">chevron_right</v-icon>
                    <v-icon style="font-size: 20px;" v-if="showCollapseIcon(props.item)" @click="categoryClicked(props.item)">expand_more</v-icon>
                  </td>
                  <td class="text-xs-left" @click="categoryClicked(props.item)" style="width: 20px; padding-left: 4px !important; padding-right: 0 !important; cursor: pointer;">
                    <div v-if="showCategory(props.item)">
                      <div v-if="props.item.category.color && !(props.item.category.color.secondColor && props.item.category.color.secondColor !== '')" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background-color: #' + props.item.category.color.color + ';'"></div>
                      <div v-if="props.item.category.color && props.item.category.color.secondColor && props.item.category.color.secondColor !== ''" :style="'margin: 3px 5px 3px 2px; border-radius: 3px; border: 1px solid #BBBBBB; width: 16px; height: 16px; background: repeating-linear-gradient(-45deg, #' + props.item.category.color.color + ', #' + props.item.category.color.color + ' 3px, #' + props.item.category.color.secondColor + ' 3px, #' + props.item.category.color.secondColor + ' 6px);'"></div>
                    </div>
                  </td>
                  <td class="text-xs-left" style="width: 650px;">
                    <div v-if="showCategory(props.item)" @click="categoryClicked(props.item)" style="padding-top: 2px; cursor: pointer;">
                      {{ props.item.category.displayLabel }}
                    </div>
                    <div v-if="showField(props.item)" class="field">
                      {{ props.item.field.displayName }}
                    </div>
                    <div v-if="showSubTotal(props.item)" class="subTotal">
                      Subtotal
                    </div>
                    <div v-if="showTotal(props.item)" class="total">
                      Total
                    </div>
                  </td>
                  <td class="text-xs-right amount" style="width: 100px !important;">{{ showEstimated(props.item) ? props.item.estimatedAmount.toLocaleString() : '' }}</td>
                  <td class="text-xs-right amount" style="width: 100px !important;">{{ showLabelled(props.item) ? props.item.labelledAmount.toLocaleString() : '' }}</td>
                  <td class="text-xs-right amount" style="width: 100px !important;">{{ showAvailable(props.item) ? props.item.availableAmount.toLocaleString() : '' }}</td>
                  <td class="text-xs-right amount" style="width: 140px !important;">
                    <div v-if="showPlanned(props.item)" style="display: inline;">
                      {{ props.item.plannedAmount.toLocaleString() }}
                    </div>
                    <div v-if="showPlanned(props.item) && hasLabelledAmount(props.item)" style="display: inline;">
                      / {{ Number(Number(100 * props.item.plannedAmount / getLabelledAmount(props.item)).toFixed(0)).toLocaleString() + '%' }}
                    </div>
                  </td>
                  <td class="text-xs-right amount" style="width: 140px !important;">
                    <div v-if="showDelivered(props.item)" style="display: inline;">
                      {{ props.item.deliveredAmount.toLocaleString() }}
                    </div>
                    <div v-if="showDelivered(props.item) && props.item.labelledAmount > 0" style="display: inline;">
                      / {{ Number(Number(100 * props.item.deliveredAmount / props.item.labelledAmount).toFixed(0)).toLocaleString() + '%' }}
                    </div>
                  </td>
                  <td></td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer/>
  </v-app>
</template>

<script>
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import Footer from '../components/Footer'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Supplier',
  components: { Header, Sidebar, Footer },
  data () {
    return {
      headers: [
        { text: '', sortable: false },
        { text: '', sortable: false },
        { text: 'Category', value: 'category.label', sortable: false },
        { text: 'Estimated', value: 'estimatedAmount', align: 'right', sortable: false },
        { text: 'Labelled', value: 'labelledAmount', align: 'right', sortable: false },
        { text: 'Status', value: 'availableAmount', align: 'right', sortable: false },
        { text: 'Planned', value: 'plannedAmount', align: 'right', sortable: false },
        { text: 'Delivered', value: 'deliveredAmount', align: 'right', sortable: false },
        { text: '', sortable: false }
      ],
      supplierOverview: false,
      supplierSummaries: [],
      filterSuppliers: [],
      filterSupplierList: [],
      filterFields: [],
      filterFieldList: [],
      expandedCategories: new Map(),
      updateCounter: 0
    }
  },
  created: function () {
    this.$store.dispatch('page/setSidebarItem', {key: 'supplier'})
    this.loadSupplierSummaries()
    this.loadFilterSuppliers()
    this.loadFilterFields()
  },
  computed: {
    showSupplier: function () {
      return this.supplierOverview
    },
    ...mapGetters({
      sessionSalesOrganizations: 'session/getSalesOrganizations'
    })
  },
  methods: {
    async loadSupplierSummaries () {
      this.supplierOverview = false
      this.supplierSummaries = []
      let supplierIds = []
      for (let s of this.filterSupplierList) {
        supplierIds.push(s.id)
      }
      let fieldIds = []
      for (let f of this.filterFieldList) {
        fieldIds.push(f.id)
      }
      let params = ''
      if (supplierIds.length > 0) {
        params += (params !== '' ? '&' : '?')
        params += 'suppliers=' + supplierIds.join(',')
      }
      if (fieldIds.length > 0) {
        params += (params !== '' ? '&' : '?')
        params += 'fields=' + fieldIds.join(',')
      }
      await axios.get('/backend/rest/supplier_overview/summary' + params)
        .then(response => {
          this.supplierSummaries = response.data
          this.supplierOverview = true
          if (this.supplierSummaries) {
            let estimatedTotal = 0
            let labelledTotal = 0
            let availableTotal = 0
            for (let summary of this.supplierSummaries) {
              if (summary.category) {
                this.expandedCategories.set(summary.category.id, false)
              }
              if (summary.subTotal) {
                estimatedTotal += summary.estimatedAmount
                labelledTotal += summary.labelledAmount
                availableTotal += summary.availableAmount
              }
            }
            this.supplierSummaries.push({
              subTotal: false,
              type: 'total',
              estimatedAmount: estimatedTotal,
              labelledAmount: labelledTotal,
              availableAmount: availableTotal
            })
          }
        })
    },
    loadFilterSuppliers () {
      axios.get('/backend/rest/supplier')
        .then(response => {
          this.filterSuppliers = response.data
        })
    },
    loadFilterFields () {
      axios.get('/backend/rest/field')
        .then(response => {
          this.filterFields = response.data
          this.filterFields.sort(function (f1, f2) {
            return f1.displayName.localeCompare(f2.displayName)
          })
        })
    },
    showCategory (summary) {
      return summary.category && !summary.field
    },
    showField (summary) {
      return summary.field
    },
    showEstimated (summary) {
      return summary.estimatedAmount > 0
    },
    showLabelled (summary) {
      return summary.labelledAmount > 0 || summary.hasLabelledAmount
    },
    showAvailable (summary) {
      return summary.availableAmount > 0 || summary.hasLabelledAmount
    },
    showPlanned (summary) {
      return summary.plannedAmount > 0
    },
    hasLabelledAmount (summary) {
      return this.getLabelledAmount(summary) > 0
    },
    getLabelledAmount (summary) {
      if (summary.field === null) {
        return summary.labelledAmount
      } else if (summary.field && summary.field.id > 0) {
        return summary.labelledAmount
      } else if (summary.field && summary.field.id === 0 && summary.field.supplierId > 0 && summary.category && summary.category.id) {
        // Get all labelled amounts for the supplier
        let labelledAmount = 0
        for (let supplierSummary of this.supplierSummaries) {
          if (supplierSummary.category && supplierSummary.category.id === summary.category.id && supplierSummary.field && supplierSummary.field.id > 0 && supplierSummary.field.supplierId === summary.field.supplierId && supplierSummary.labelledAmount > 0) {
            labelledAmount += supplierSummary.labelledAmount
          }
        }
        return labelledAmount
      }
      return 0
    },
    showDelivered (summary) {
      return summary.deliveredAmount > 0
    },
    rowClass (summary) {
      return this.showCategory(summary) || this.showField(summary) ? 'field' : this.showSubTotal(summary) ? 'subTotal' : 'total'
    },
    showItem (summary) {
      return this.showCategory(summary) || summary.subTotal || (summary.category && this.expandedCategories.get(summary.category.id)) || summary.type === 'total'
    },
    showSubTotal (summary) {
      return summary.subTotal
    },
    showTotal (summary) {
      return summary.type === 'total'
    },
    showExpandIcon (summary) {
      return this.showCategory(summary) && !this.expandedCategories.get(summary.category.id) && !(summary.type === 'total')
    },
    showCollapseIcon (summary) {
      return this.showCategory(summary) && this.expandedCategories.get(summary.category.id) && !(summary.type === 'total')
    },
    categoryClicked (summary) {
      let expanded = this.expandedCategories.get(summary.category.id)
      expanded = !expanded
      this.expandedCategories.set(summary.category.id, expanded)
      this.updateCounter++
    }
  },
  watch: {
    sessionSalesOrganizations () {
      this.filterSuppliers = []
      this.filterSupplierList = []
      this.filterFields = []
      this.filterFieldList = []
      this.loadSupplierSummaries()
      this.loadFilterSuppliers()
      this.loadFilterFields()
    }
  }
}
</script>
<style scoped>
html {
  overflow-y: auto;
}
tr.total td.amount,
tr.field td.amount {
  padding-right: 18px !important;
  padding-top: 2px !important;
}
tr td.category:not(:first-child) {
  width: 200px;
  padding-right: 25px !important;
}
tr td.amount:not(:first-child) {
  padding: 2px 10px !important;
}
tr td.category,
tr td.amount {
  white-space: nowrap;
}
tr.field td div.field,
tr.field td.amount {
}
tr.field td div.field {
  padding-left: 10px;
}
tr.total td.total,
tr.total td.amount {
  padding-top: 2px !important;
}
tr.subTotal td,
tr.total td {
  font-weight: bold;
  color: rgba(0, 0, 0, 0.54);
}
tr.subTotal td.category,
tr.subTotal td.amount {
  padding-bottom: 10px !important;
}
tr.total td div.total,
tr.total td.amount {
  padding-top: 10px !important;
}
tr.subTotal td div.subTotal {
  padding-top: 2px !important;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/Supplier.vue